import React, { useEffect, useRef } from 'react';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import logo from '../../assents/img/traveller_logo.svg';
import easLogo from '../../assents/img/easLogo.png';
import { BACKEND_URL } from '../../constans';

const Hero = styled(Box, {
    shouldForwardProp: (propName) => propName !== 'heroImg',
})(({ theme, heroImg }) => ({
    height: '291px',
    backgroundImage: `url(${heroImg})`,
    backgroundPosition: 'bottom',
    backgroundSize: 'cover',
    boxSizing: 'border-box',
    [theme.breakpoints.up('sm')]: {
        height: '490px',
        backgroundPosition: 'initial',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
        backgroundSize: '101%',
    },
}));

const Logo = styled('img')(({ theme }) => ({
    height: '35px',
    width: '100px',
    marginTop: '20px',
    marginLeft: '20px',
    filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
    [theme.breakpoints.up('sm')]: {
        marginTop: '21px',
        marginLeft: '25px',
    },
}));
const EasLogo = styled('img')(({ theme }) => ({
    height: '40px',
    width: '130px',
    marginTop: '20px',
    marginRight: '20px',
    cursor: 'pointer',
    filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
    [theme.breakpoints.up('sm')]: {
        marginTop: '21px',
        marginLeft: '25px',
    },
}));

const TitleBlock = styled(Box)(({ theme }) => ({
    textAlign: 'center',
    width: '440px',
    margin: '0px auto',
    marginTop: '20px',
    [theme.breakpoints.up('sm')]: {
        marginTop: '70px',
    },
}));

const SubTitile = styled(Typography)(({ theme }) => ({
    fontFamily: 'Proxima Nova',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: 1.22,
    letterSpacing: '-0.02em',
    color: '#ffffff',
    textShadow: '0px 1px 3px rgba(0, 0, 0, 0.2)',
    filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
}));

const Title = styled(Typography)(({ theme }) => ({
    marginTop: '5px',
    fontFamily: 'Rubik',
    fontSize: '30px',
    fontWeight: 500,
    lineHeight: 1,
    letterSpacing: '-0.02em',
    color: '#ffffff',
    filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
    textShadow: '0px 1px 3px rgba(0, 0, 0, 0.2)',
    [theme.breakpoints.up('sm')]: {
        marginTop: '0px',
        fontSize: '44px',
        lineHeight: 1.18,
    },
}));

const HeroBlock = ({ tourDataInfo, isMobile }) => {
    const titleBlock = useRef();
    useEffect(() => {
        if (isMobile) {
            titleBlock.current.style.width = '335px';
        } else {
            titleBlock.current.style.width = '440px';
        }
    }, [isMobile]);

    return (
        <Hero heroImg={`${BACKEND_URL}${tourDataInfo.image}`}>
            <Box display='flex' justifyContent='space-between'>
                <Logo src={logo} alt='logo' />
                {!isMobile && (
                    <EasLogo
                        onClick={() =>
                            (window.location.href =
                                'https://www.traveller.ee/blog/other/eas-toetab-traveller-toursi-arimudeli-uuendamist/')
                        }
                        src={easLogo}
                        alt='eas-logo'
                    />
                )}
            </Box>
            <TitleBlock ref={titleBlock}>
                <Title>Start customizing your tour</Title>
            </TitleBlock>
        </Hero>
    );
};

export default HeroBlock;
